import {
  Component,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { AppAnimations } from '../../../../animations';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NkNavHorizontalItemComponent } from '../nav-item/nav-horizontal-item.component';
// import { NkNavVerticalCollapseComponent } from '../../vertical/nav-collapse/nav-vertical-collapse.component';

@Component({
  selector: 'app-nav-horizontal-collapse',
  templateUrl: './nav-horizontal-collapse.component.html',
  styleUrls: ['./nav-horizontal-collapse.component.scss'],
  animations: AppAnimations,
  imports:[
    RouterModule,
    MatIconModule,
    CommonModule,
    NkNavHorizontalItemComponent,
    // NkNavVerticalCollapseComponent
  ]
})
export class NkNavHorizontalCollapseComponent implements OnDestroy {
  onConfigChanged!: Subscription;
  // nkSettings = { colorClasses: { navbar: 'mat-red-bg' } };
  isOpen = false;

  @HostBinding('class') classes = 'nav-item nav-collapse';
  @Input() item: any;

  @HostListener('mouseenter')
  open() {
    this.isOpen = true;
  }

  @HostListener('mouseleave')
  close() {
    this.isOpen = false;
  }

  constructor(/* private nkConfig: NkConfigService */) {
    // this.onConfigChanged = this.nkConfig.onConfigChanged.subscribe(
    //   (newSettings) => {
    //     this.nkSettings = newSettings;
    //   }
    // );
  }

  ngOnDestroy() {
    if (this.onConfigChanged) {
      this.onConfigChanged.unsubscribe();
    }
  }

  
}
